import * as yup from 'yup';

export const validationsSchema = yup.object({
  activity_code: yup.string().nullable(),
  activity_description: yup.string().nullable(),
  activity_industry_sector: yup.string().nullable(),
  alter_summary_address: yup.string().nullable(),
  alter_summary_employees_nr: yup
    .number('Deve essere un numero')
    .transform((value, originalValue) => (String(originalValue).trim() === '' ? null : value))
    .required('Il campo è obbligatorio. Inserisci numero di dipendenti!')
    .test(
      'is-number-and-positive',
      'Deve essere un numero e maggiore di 0',
      (value) => value === null || (typeof value === 'number' && value > 0),
    ),
  alter_summary_incorporation_date: yup.string().nullable(),
  alter_summary_province: yup.string().nullable(),
  alter_summary_share_capital: yup.string().nullable(),
  business_name: yup.string().nullable(),
  company_id: yup.string().nullable(),
  company_number: yup.string().nullable(),
  company_registration_number: yup.string().nullable(),
  company_status: yup.string().nullable(),
  credit_rating_common_desc: yup.string().nullable(),
  credit_rating_common_value: yup.string().nullable(),
  credit_rating_limit_value: yup.string().nullable(),
  summary_extra_has_cigs_events: yup.string().nullable(),
  summary_extra_has_company_insolvency: yup.string().nullable(),
  summary_extra_has_insolvency: yup.string().nullable(),
  summary_extra_has_prejudicials: yup.string().nullable(),
  summary_extra_has_protesti: yup.string().nullable(),
  summary_extra_has_severe_prejudicials: yup.string().nullable(),
  summary_extra_has_severe_protesti: yup.string().nullable(),
  turnover_value: yup.number('Deve essere un numero')
    .transform((value, originalValue) => (String(originalValue).trim() === '' ? null : value))
    .required('Il campo è obbligatorio. Inserisci Valore del Fatturato!')
    .test(
      'is-number-and-positive',
      'Deve essere un numero e maggiore di 0',
      (value) => value === null || (typeof value === 'number' && value > 0),
    ),
  phone: yup
    .string()
    .required('Il campo è obbligatorio. Inserisci numero di telefono!')
    .matches(/^[3]{1}[0-9]{8,9}$/, 'Il numero non è corretto'),
  email: yup
    .string()
    .required('Il campo è obbligatorio. Inserisci Email!')
    .email('Deve essere un email valido! Rimuovi spazi vuoti!'),
  company_commentaries: yup.array().nullable(),
  share_holders: yup.array().nullable(),
  directors: yup.array().nullable(),
  extended_group_structure: yup.array().nullable(),
  company_branches: yup.array().of(
    yup.object().shape({
      address: yup.string().required('Indirizzo è obbligatorio'),
      description: yup.string().required('Descrizione è obbligatoria'),
      year_of_construction: yup.string().required('Anno di costruzione è obbligatorio'),
      number_of_floors: yup.string().required('Numero di piani è obbligatorio'),
      type_of_construction: yup.string().required('Tipo di costruzione è obbligatorio'),
      presence_of_alarm_system: yup.string().required('Presenza di sistema di allarme è obbligatoria'),
      fabricated: yup.string().required('Fabbricato è obbligatorio'),
      manufactured_value: yup
        .string()
        .required('Valore di fabbricazione è obbligatorio')
        .matches(/^[1-9]\d*([a-zA-Z]|\/(\d+[a-zA-Z]?|[a-zA-Z]+))?$/, 'Il numero deve essere maggiore di 0.'),
      content_value: yup
        .string()
        .required('Valore del contenuto è obbligatorio')
        .matches(/^[1-9]\d*([a-zA-Z]|\/(\d+[a-zA-Z]?|[a-zA-Z]+))?$/, 'Il numero deve essere maggiore di 0.'),
      value_of_electronic_equipment: yup.string().required('Valore delle apparecchiature elettroniche è obbligatorio'),
    }),
  ).required('Il campo è obbligatorio.').min(1, 'Il campo non può essere vuoto.'),
  company_indicators: yup.array().nullable(),
});

export const commercialCompanyDefaultValues = {
  activity_code: '',
  activity_description: '',
  activity_industry_sector: '',
  alter_summary_address: '',
  alter_summary_employees_nr: '',
  alter_summary_incorporation_date: '',
  alter_summary_province: '',
  alter_summary_share_capital: '',
  business_name: '',
  company_id: '',
  company_number: '',
  company_registration_number: '',
  company_status: '',
  credit_rating_common_desc: '',
  credit_rating_common_value: '',
  credit_rating_limit_value: '',
  summary_extra_has_cigs_events: '',
  summary_extra_has_company_insolvency: '',
  summary_extra_has_insolvency: '',
  summary_extra_has_prejudicials: '',
  summary_extra_has_protesti: '',
  summary_extra_has_severe_prejudicials: '',
  summary_extra_has_severe_protesti: '',
  email: '',
  phone: '',
  turnover_value: '',
  company_commentaries: [],
  share_holders: [],
  directors: [],
  extended_group_structure: [],
  company_branches: [],
  company_indicators: [],
  payment_frequency: '',
  guarantees: [
    {
      tipo_bene: 'RTC',
      benes: [
        {
          progresivo_parametro: '2',
          valore_parametro: '',
        },
      ],
    },
  ],
  technical_location_data: {
    annor_value: null,
    annoc_value: null,
    tpab_value: '',
    attpr_value: '',
  },
  company_address: '',
  company_house_number: '',
  company_residence_commune_code: '',
  company_residence_province_code: '',
  company_postal_code: '',
  address: '',
  house_number: '',
  residence_commune_code: '',
  residence_province_code: '',
  postal_code: '',
  gender: '',
  company_name: '',
  fiscal_code: '',
  name: '',
  surname: '',
  date_of_birth: '',
  effective_date: '',
  property_value: '',

};

export const answersFieldsBySteps = [
  [
    'activity_code',
    'activity_description',
    'activity_industry_sector',
    'alter_summary_address',
    'alter_summary_employees_nr',
    'alter_summary_incorporation_date',
    'alter_summary_province',
    'alter_summary_share_capital',
    'business_name',
    'company_id',
    'company_number',
    'company_registration_number',
    'company_status',
    'credit_rating_common_desc',
    'credit_rating_common_value',
    'credit_rating_limit_value',
    'summary_extra_has_cigs_events',
    'summary_extra_has_company_insolvency',
    'summary_extra_has_insolvency',
    'summary_extra_has_prejudicials',
    'summary_extra_has_protesti',
    'summary_extra_has_severe_prejudicials',
    'summary_extra_has_severe_protesti',
    'turnover_value',
  ],
  [
    'company_commentaries',
  ],
  [
    'share_holders',
  ],
  [
    'directors',
  ],
  [
    'extended_group_structure',
  ],
  [
    'commercial_company_financial_statements',
  ],
  [
    'company_branches',
  ],
  [
    'company_indicators',
  ],
  ['email', 'phone'],
];

export const validationSchemaCommercialCatastrophe = yup.object({
  vat_number: yup.string().required(),
  sub_product: yup.string().required(),
  contractor_declaration: yup.object().shape({
    in_good_condition: yup
      .string()
      .required(
        'Il campo è obbligatorio. Confermare se il fabbricato è in buone condizioni.',
      ), // 1. Il fabbricato è in buone condizioni di statica e manutenzione?
    has_building_violation: yup
      .string()
      .required(
        'Il campo è obbligatorio. Confermare se il fabbricato risulta gravato da abuso edilizio.',
      ), // 2. Il fabbricato risulta gravato da abuso edilizio?
    under_construction: yup
      .string()
      .required(
        'Il campo è obbligatorio. Confermare se il fabbricato è in corso di costruzione, ristrutturazione o ampliamento.',
      ), // 3. Il fabbricato è in corso di costruzione, ristrutturazione o ampliamento?
    meets_insurance_requirements: yup
      .string()
      .required(
        'Il campo è obbligatorio. Confermare se il fabbricato risponde ai requisiti di assicurabilità.',
      ), // 4. Risponde ai requisiti di assicurabilità?
    matches_insured_data: yup
      .string()
      .required(
        'Il campo è obbligatorio. Confermare se il fabbricato risponde ai dati del fabbricato assicurato.',
      ), // 4. Risponde ai dati del fabbricato assicurato?
    no_other_policies: yup
      .string()
      .required(
        'Il campo è obbligatorio. Confermare se non sono in vigore altre polizze per gli stessi rischi.',
      ), // 5. Non sono in vigore altre polizze per gli stessi rischi?
    no_canceled_policies: yup
      .string()
      .required(
        'Il campo è obbligatorio. Confermare se nessuna polizza annullata nel triennio precedente.',
      ), // 6. Nessuna polizza annullata nel triennio precedente?
    no_past_damages: yup
      .string()
      .required(
        'Il campo è obbligatorio. Confermare se nessun evento dannoso nel triennio precedente.',
      ), // 6. Nessun evento dannoso nel triennio precedente?
  }),
  type: yup.object().shape({
    building_type: yup
      .string()
      .required(
        'Il campo è obbligatorio. Selezionare la tipologia di fabbricato.',
      ), // Tipologia di fabbricato
    activity_type: yup
      .string()
      .required("Il campo è obbligatorio. Selezionare l'attività svolta."), // Selezionare l'attività svolta
  }),
  other_data: yup.object().shape({
    building_plans: yup
      .number()
      .typeError('Solo numeri sono ammessi!') // Ensures type error message for non-numeric values
      .integer('Deve essere un numero intero!') // Ensures only whole numbers
      .required(
        "Il campo è obbligatorio. Confermare se sono disponibili i piani dell'edificio.",
      ), // Piani dell'edificio
    construction_year: yup
      .string()
      .required("Il campo è obbligatorio. Confermare l'anno di costruzione."), // Anno di costruzione
    construction_typology: yup
      .string()
      .required(
        'Il campo è obbligatorio. Confermare la tipologia di costruzione.',
      ), // Construction typology - vertical load-bearing structures
    occupied_floor: yup
      .string()
      .nullable(),
  }),
  coverage: yup.object().shape({
    catastrophic_building_coverage: yup
      .boolean()
      .required(
        'Seleziona un’opzione per la copertura eventi catastrofali fabbricato',
      ),
    catastrophic_building_coverage_value: yup
      .string()
      .nullable()
      .when(
        'catastrophic_building_coverage',
        ([catastrophic_building_coverage], schema) => (catastrophic_building_coverage == '1'
          ? schema.required('Campo obbligatorio')
          : schema),
      ),

    catastrophic_content_machinery_coverage: yup
      .boolean()
      .required(
        'Seleziona un’opzione per la copertura eventi catastrofali - impianti e macchinari',
      ),
    catastrophic_content_machinery_coverage_value: yup
      .string()
      .nullable()
      .when(
        'catastrophic_content_machinery_coverage',
        ([catastrophic_content_machinery_coverage], schema) => (catastrophic_content_machinery_coverage == '1'
          ? schema.required('Campo obbligatorioi')
          : schema),
      ),

    catastrophic_content_equipment_coverage: yup
      .boolean()
      .required(
        'Seleziona un’opzione per la copertura eventi catastrofali - attrezzature industriali e commerciali',
      ),
    catastrophic_content_equipment_coverage_value: yup
      .string()
      .nullable()
      .when(
        'catastrophic_content_equipment_coverage',
        ([catastrophic_content_equipment_coverage], schema) => (catastrophic_content_equipment_coverage == '1'
          ? schema.required('Campo obbligatorio')
          : schema),
      ),

    catastrophic_land_coverage: yup
      .boolean()
      .required(
        'Seleziona un’opzione per la copertura eventi catastrofali terreno',
      ),
    catastrophic_land_coverage_value: yup
      .string()
      .nullable()
      .when(
        'catastrophic_land_coverage',
        ([catastrophic_land_coverage], schema) => (catastrophic_land_coverage == '1'
          ? schema.required('Campo obbligatorio')
          : schema),
      ),
  }),
  relations: yup.object().shape({
    owner_contractor_relation: yup
      .string()
      .required(
        'Il campo è obbligatorio. Selezionare il rapporto fra proprietario e contraente.',
      ), // Rapporto fra proprietario e contraente
  }),
  phone: yup
    .string()
    .required('Il campo è obbligatorio. Inserisci numero di telefono!')
    .matches(/^[3]{1}[0-9]{8,9}$/, 'Il numero non è corretto'),
  email: yup
    .string()
    .required('Il campo è obbligatorio. Inserisci Email!')
    .email('Deve essere un email valido! Rimuovi spazi vuoti!'),
}).test(
  'occupied-floors-required-if-porzione',
  'Campo obbligatorio',
  function (value) {
    const buildingType = value?.type?.building_type;
    const occupiedFloors = value?.other_data?.occupied_floor;

    if (buildingType === 'Porzione di fabbricato' && !occupiedFloors) {
      return this.createError({
        path: 'other_data.occupied_floor',
        message: 'Campo obbligatorio',
      });
    }

    return true;
  },
);

export const answersFieldsByStepsCatastrophe = [
  [
    'contractor_declaration',
  ],
  [
    'type',
  ],
  [
    'other_data',
  ],
  [
    'coverage',
  ],
  [
    'relations',
  ],
  ['email', 'phone'],
];
